<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商学院课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/directWatchList')">直播列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='申请人'>
            <el-input
              clearable
              style="width:500px"
              v-model="filters.keyword"
              placeholder="请输入名称搜索"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select
              v-model="filters.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="已上架"
                value="2"
              ></el-option>
              <el-option
                label="已关闭"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团队类型">
            <el-select
              v-model="filters.infoType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="陈"
                value="1"
              ></el-option>
              <el-option
                label="孙"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="标题"
            prop="info_title"
          >
          </el-table-column>

          <el-table-column
            label="申请人姓名"
            prop="username"
          >
          </el-table-column>

           <el-table-column
            label="申请人手机号"
            prop="telephone"
          >
          </el-table-column>

          
          <el-table-column
            :formatter="formatterRoleType"
            prop="role_type"
            label="申请人角色"
          >
          </el-table-column>

          <el-table-column
            label="申请时间"
            prop="create_time1"
          >
          </el-table-column>


          <el-table-column
            label="团队类型"
            prop="team_type"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.team_type == 2">孙</span>
            <span v-if="scope.row.team_type == 1">陈</span>
            <span v-if="scope.row.team_type == null">--</span>
          </template>
          </el-table-column>

           <el-table-column
            label="邀请码"
            prop="invite_code"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.invite_code != null">{{scope.row.invite_code}}</span>
            <span v-else>--</span>
          </template>
          </el-table-column>

           <el-table-column
            label="主讲人"
            prop="speak_user"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.speak_user != null">{{scope.row.speak_user}}</span>
            <span v-else>--</span>
          </template>
          </el-table-column>


          <el-table-column
            :formatter="formatterRoleInfo"
            prop="role_list"
            label="对应角色"
          >
          </el-table-column>

          <el-table-column
            prop="some_user"
            label="临时可见"
          >
          </el-table-column>

          <el-table-column label="主讲人头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.speak_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                type="info"
                disable-transitions
              >已上架</el-tag>
              <el-tag
                v-if="scope.row.status == 3"
                type="info"
                disable-transitions
              >关闭</el-tag>
            </template>
          </el-table-column>


          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="hasPower('90018991') && scope.row.status == 1"
                @click="addPostDialog(scope.row)"
                type="text"
                size="small"
              >上架</el-button>
              <!-- <el-button
                v-if="scope.row.status == 2"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
                size="small"
              >取消上架</el-button> -->
              <el-button
                v-if="hasPower('90018991') && scope.row.status == 2"
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >关闭</el-button>
              <el-button
                v-if="hasPower('90018991') && scope.row.status == 2"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button
              v-if="hasPower('90018991') &&  (scope.row.status == 3 || scope.row.status == 1)"
                @click="upHouseStatus(scope.row, 4)"
                type="text"
                size="small"
              >删除</el-button>
              <el-button
                @click="showStuUser(scope.row)"
                type="text"
                size="small"
              >查看聊天记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div><div id="qrCodeUrl" class="qrcode" ref="qrCodeUrl"></div></div>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
         <el-form-item
          label="主讲人"
          prop='speakUser'
        >
          <el-input v-model="form.speakUser"></el-input>
        </el-form-item>

        <el-form-item label="主讲人头像" prop="speakHead" >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>
    
         <el-form-item
          label="团队"
          prop="teamType"
        >
           <el-select
              v-model="form.teamType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="陈"
                value="1"
              ></el-option>
              <el-option
                label="孙"
                value="2"
              ></el-option>
            </el-select>
        </el-form-item>


        <el-form-item
          width='400px'
          label="对应角色"
          prop="roleInfo"
        >
          <el-select
            multiple
            v-model="form.roleInfo"
            placeholder="请选择"
          >
            <el-option
              v-for="option in roleTypeList"
              :value="option"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="临时可见用户"
          prop='someUser'
        >
          <el-input v-model="form.someUser" placeholder=""></el-input>
          <span style="color:#d58206">请填写用户手机号，多个因为逗号隔开</span>
        </el-form-item>


        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="上架"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="主讲人"
          prop='speakUser'
        >
          <el-input v-model="form.speakUser"></el-input>
        </el-form-item>

        <el-form-item label="主讲人头像" prop="speakHead" >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>
    
         <el-form-item
          label="团队"
          prop="teamType"
        >
           <el-select
              v-model="form.teamType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="陈"
                value="1"
              ></el-option>
              <el-option
                label="孙"
                value="2"
              ></el-option>
            </el-select>
        </el-form-item>


        <el-form-item
          width='400px'
          label="对应角色"
          prop="roleInfo"
        >
          <el-select
            multiple
            v-model="form.roleInfo"
            placeholder="请选择"
          >
            <el-option
              v-for="option in roleTypeList"
              :value="option"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >上架</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    
    <el-dialog
      title="学习人员"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="username"
          label="姓名"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="手机号"
        >
        </el-table-column>
          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>
        <el-table-column
          prop="role_type"
          :formatter="formatterRoleType"
          label="代理类型"
        >
        </el-table-column>
        <el-table-column
          prop="create_time1"
          label="时间"
        >
        </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import QRCode from "qrcodejs2";
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
export default {
  name: "judgeTypeList",
  created() {},

  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      subListVisible:false,
      page_size1:10,
      detailListLoading:false,
      tableDetailData:[],
      total_num1:0,
      total_page1:0,
      page_num1:1,
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        roleInfo: [
          { required: true, message: "请选择可看角色", trigger: "blur" }
        ],
        speakHead: [
          { required: true, message: "请上传主讲人头像", trigger: "blur" }
        ],
        speakUser: [
          { required: true, message: "请填写主讲人", trigger: "blur" }
        ],
        teamType: [
          { required: true, message: "请选择团队类型", trigger: "blur" }
        ],
      },
      addLoading: false,
      recoOptions: [
        { text: "线上", value: "1" },
        { text: "线下", value: "2" }
      ],
      roleTypeList: [
        { text: "康减系列vip会员", value: "-0.5" },
        { text: "康减系列高级会员", value: "-0.4" },
        { text: "康减系列荣誉会员", value: "-0.3" },
        { text: "康减系列市代", value: "1.1" },
        { text: "康减系列省代", value: "2.1" },
        { text: "康减系列CEO", value: "3.1" },
        { text: "VIP门店", value: "0.0" },
        { text: "联盟店", value: "1.0" },
        { text: "优秀联盟店", value: "1.05" },
        { text: "市代", value: "2.0" },
        { text: "省代", value: "3.0" },
        { text: "CEO", value: "4.0" },
        { text: "总经销商", value: "5.0" },
        { text: "合伙人", value: "2.2" },
        { text: "董事", value: "4.2" },
        { text: "区域总监", value: "5.1" },
        { text: "城市加盟商", value: "5.2" },
        { text: "经销商", value: "4.8" }
      ],
      stuTypeList:[],
      loading: false,
      form: {
        title: null,
        orderIndex: null,
        speakHead:null,
        teamType:null,
        speakUser:null,
        roleType:null,
        roleInfo:null,
        someUser:null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
    this.getStuType();
  },
  methods: {
    creatQrCode(str) {
        this.dialogVisible = true
      setTimeout(() => {
        document.querySelector("#qrCodeUrl").innerHTML = ""
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: 'JSYMR:' + str.id + '', // 需要转换为二维码的内容
          width: 150,
          height: 150,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcode.clear();
        this.qrcode.makeCode('JSYMR:' + str.id + '');
      }, 500)
    },
    formatterRoleInfo(row){
      if (row.role_list == null || row.role_list == '')
      {
        return '--';
      } else
      {
        var list = JSON.parse(row.role_list);
        var names = [];
        list.forEach(function (e){
          names.push(e.text)
        })
        return names.join(',');
      }
    },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.speakHead = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
     formatterRoleType(row, column) {
       if(row.role_type == null)
       {return '--'}
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == -0.5) {
        return "康减系列";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      }  else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 1.05) {
        return "优秀门店";
      }  else if (row.role_type == 2.2) {
        return "合伙人";
      }  else if (row.role_type == 4.2) {
        return "董事";
      }  else if (row.role_type == 5.1) {
        return "区域总监";
      }  else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },
    showStuUser(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.searchDetail(row.id);
    },
    
    searchDetail(courseId) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        courseId:courseId,
        page_num: that.page_num1,
        page_size: that.page_size1
      };
      that.detailListLoading = true;
      API.stu_course_user_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.roleInfo = JSON.stringify(para.roleInfo);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.up_direct_watch(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "上架成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPost() {
      var that = this;
      let para = Object.assign({}, that.form);
      para.token = localStorage.getItem("api_token");
      para.roleInfo = JSON.stringify(para.roleInfo);
      if (para.someUser == null)
      {
        para.someUser = '';
      }
      this.addLoading = true;
      API.change_watch_info(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPostDialog(row) {
      this.form.title = null;
      this.form.id = row.id;
      this.form.speakUser = null;
      this.form.roleInfo = null;
      this.form.teamType = null;
      this.dialogAddVisible = true;
    },
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.speakUser = row.speak_user;
      this.form.roleInfo = JSON.parse(row.role_list);
      this.form.teamType = row.team_type + '';
      this.form.someUser = row.some_user;
      this.form.speakHead = row.speak_head;
      this.dialogEditVisible = true;
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 4) {
        m1 = "确定删除该直播吗？";
        m2 = "删除成功后，app和后台都不显示该直播";
        m3 = "删除成功";
        type = "warning";
        this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: 4
          };
          API.statue_direct_watch(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
      } else  if (status == 3) {
        m1 = "确定关闭该直播吗？";
        m2 = "关闭成功后，app不显示该直播";
        m3 = "关闭成功";
        type = "error";
        this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status:3
          };
          API.statue_direct_watch(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
      }

    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    search() {
      let that = this;

      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.infoType) {
        params.team_type = that.filters.infoType;
      }
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.username = that.filters.keyword;
      }
      that.loading = true;

        API.direct_watch_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.total_num = result.result.count;
                that.total_page = result.result.allPageNumber;
                if (result.result.list && result.result.list.length > 0) {
                  for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                }
                that.tableData = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    
    getStuType() {
      let that = this;
      let params = {
        pageNum: 1,
        pageSize: 100,
        token: localStorage.getItem("api_token")
      };
        API.stu_course_type_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.stuTypeList = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {this.dialogVisible = false},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/directWatchList.vue